import { createContext, useContext } from 'react';

export type Apps = 'home' | 'goals' | 'teams';

export const AppContext = createContext({
  app: 'home' as Apps,
});

export const useTownsquareApp = () => {
  const ctx = useContext(AppContext);

  return ctx.app;
};
